
export class BOCurrentPathColor{
mEvent?: MouseEvent | null;
    zone: string | null;
    stateId: number | null;

    constructor() {
        this.mEvent = null;
        this.zone = null;
        this.stateId = null;
    }
}
